export default __webpack_public_path__ + "static/media/016-paint.0eb7fc89.svg";